<!--begin::Main-->
<div class="d-flex flex-column flex-root">
	<!--begin::Login-->
	<div class="login login-3 wizard d-flex flex-column flex-lg-row flex-column-fluid">
		<!--begin::Aside-->
		<div class="login-aside d-flex flex-column flex-row-auto"
			style="box-shadow: inset -10px 0px 10px -10px rgba(0,0,0,0.5);">
			<!--begin::Aside Bottom-->
			<div class="aside-img d-flex flex-row-fluid">
				<img src="assets/images/FPC.png" alt="FPC Image">
				<div class="caption">Veterinary Management</div>
			</div>
			<!--end::Aside Bottom-->
		</div>
		<!--end::Aside-->
		<div class="login-content flex-row-fluid d-flex flex-column p-10">
			<div class="d-flex flex-row-fluid flex-center">
				<!--begin::Change Password form-->
				<div class="login-form">
					<!--begin::Header-->
					<div class="login-content flex-row-fluid d-flex flex-column">
						<a href="#" class="login-logo pb-xl-15 pb-10">
							<span style="font-size:4rem;font-weight:600;color:#414e91 !important">Univet</span>
						</a>
					</div>
					<!--end::Header-->

					<div class="pb-2 pb-lg-5">
						<div class="text-muted font-weight-bold font-size-h6" (click)="backToLogin()" style="cursor: pointer;">
							<i class="las la-arrow-alt-circle-left"></i> Back to Login
						</div>
						<h3 class="font-weight-bolder text-dark font-size-h5">Change Password</h3> <br>
					</div>

					<form [formGroup]="_changePassForm">
						<div class="form-group">
							<input type="text" formControlName="Email" id="Email"
								class="form-control h-auto py-4 px-8 font-size-h6" placeholder="Email"
								[ngClass]="{ 'is-invalid': clicked && _changePassForm.controls.Email.invalid }"
								required autofocus>
							<div *ngIf="clicked && _changePassForm.controls.Email.invalid" class="invalid-feedback">
								<div *ngIf="_changePassForm.controls.Email.errors?.required" class="font-size-h6">Required</div>
							</div>
						</div>
						<div class="form-group">
							<input type="password" formControlName="OldPassword" id="OldPassword"
								class="form-control h-auto py-4 px-8 font-size-h6" placeholder="Old Password"
								[ngClass]="{ 'is-invalid': clicked && _changePassForm.controls.OldPassword.invalid }"
								required>
							<div *ngIf="clicked && _changePassForm.controls.OldPassword.invalid" class="invalid-feedback">
								<div *ngIf="_changePassForm.controls.OldPassword.errors?.required" class="font-size-h6">Required</div>
							</div>
						</div>
						<div class="form-group">
							<input type="password" formControlName="NewPassword" id="NewPassword"
								class="form-control h-auto py-4 px-8 font-size-h6" placeholder="New Password"
								[ngClass]="{ 'is-invalid': clicked && _changePassForm.controls.NewPassword.invalid }"
								required>
							<div *ngIf="clicked && _changePassForm.controls.NewPassword.invalid" class="invalid-feedback">
								<div *ngIf="_changePassForm.controls.NewPassword.errors?.required" class="font-size-h6">Required</div>
							</div>
						</div>
						<div class="form-group">
							<input type="password" formControlName="ConfirmPassword" id="ConfirmPassword"
								class="form-control h-auto py-4 px-8 font-size-h6" placeholder="Confirm Password"
								[ngClass]="{ 'is-invalid': clicked && _changePassForm.controls.ConfirmPassword.invalid }"
								(keyup.enter)="changePassword()" required>
							<div *ngIf="clicked && _changePassForm.controls.ConfirmPassword.invalid" class="invalid-feedback">
								<div *ngIf="_changePassForm.controls.ConfirmPassword.errors?.required" class="font-size-h6">Required</div>
							</div>
						</div>
						<div class="form-group">
							<button type="button" class="btn btn-lg btn-block btn-success font-weight-bold font-size-h6"
								[disabled]="isAuthenticating" style="background-color:#182845" (click)="changePassword()">
								{{ isAuthenticating ? 'Changing password...' : 'Change Password' }} &nbsp;<i *ngIf="isAuthenticating" class="fas fa-spinner fa-spin"></i>
							</button>
						</div>
					</form>
				</div>
				<!--end::Change Password form-->
			</div>
		</div>
	</div>
</div>
